export const iconFontAwesomeMapsPlug = (
	<i className="fa-solid fa-plug"></i>
);
